/**
 * CasesUnprocessed Component
 * 
 * Wrapper page for displaying unprocessed/incoming cases.
 * Uses the RecordsApp component for the main functionality.
 */

import React from 'react';
import RecordsApp from './RecordsApp';
import './Cases.css';

export default function CasesUnprocessed() {
  return (
    <div className="cases-container">
      <h1 className="cases-title">Необработанные кейсы</h1>
      <RecordsApp />
    </div>
  );
}
